import { render, staticRenderFns } from "./HeaderSlide.vue?vue&type=template&id=77e56ef0&"
import script from "./HeaderSlide.vue?vue&type=script&lang=ts&"
export * from "./HeaderSlide.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports